import styled from 'styled-components';

export const WidgetWrapper = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
`;

export const Title = styled.div`
    color: #222a34;
    font-size: 36px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 42px;
    margin-bottom: 14px;
`;

export const Content = styled.div`
    color: #222a34;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    margin-top: 20px;
`;

export const Link = styled.div`
    align-self: flex-end;
`;
